"use client"

import { Check } from "lucide-react"
import { FONT_MONO, FONT_SANS } from "@/lib/constants"
import { STEPS } from "../_types"

export function StepIndicator({ step }: { step: 1 | 2 | 3 }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 28,
        flexWrap: "wrap",
      }}
    >
      {STEPS.map((s, i) => (
        <div key={s.n} style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {i > 0 && (
            <div
              style={{
                width: 24,
                height: 1,
                background: step > s.n ? "#0EA5E9" : "var(--ljs-border)",
              }}
            />
          )}
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <div
              style={{
                width: 26,
                height: 26,
                borderRadius: "50%",
                background: step > s.n ? "#0EA5E9" : step === s.n ? "#0EA5E9" : "var(--ljs-border)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {step > s.n ? (
                <Check size={13} color="#fff" />
              ) : (
                <span
                  style={{
                    fontFamily: FONT_MONO,
                    fontSize: 11,
                    fontWeight: 700,
                    color: step === s.n ? "#fff" : "var(--ljs-text-faint)",
                  }}
                >
                  {s.n}
                </span>
              )}
            </div>
            <span
              style={{
                fontFamily: FONT_SANS,
                fontSize: 13,
                fontWeight: step === s.n ? 600 : 400,
                color: step === s.n ? "var(--ljs-text)" : "var(--ljs-text-faint)",
              }}
            >
              {s.label}
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}
